/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDom from 'react-dom';
import { ApplicationState, ConnectedReduxProps } from '../../store';
import { showWizardPage } from '../../store/wizardPage/actions';
import { Dispatch } from 'redux';
import { ResourceProvider } from '../../resourceProvider';
import { resetAll } from '../../store/filterPage/actions';
import { TabType } from '../../components/wizard/wizardTabs/WizardTabPane';
import { OverlayWindowComponent } from '../../components/overlayWindow/overlayWindow';
import { hideFilterMobilePage } from '../../store/filterMobilePage/actions';
import { FilterItem } from '../../components/filter/filterItem';

interface IPropsFromState {
    readonly isVisible: boolean,
    readonly enteredVin: string,
    readonly selectedVehicleMarketEntry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
    readonly selectedModel: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel,
    readonly selectedInfotaiment: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel,
    readonly selectedProductionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel,
    readonly importerSettings: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.ImporterSettingsModel
}

interface IPropsFromDispatch {
    readonly showWizardPage: typeof showWizardPage,
    readonly resetAll: typeof resetAll,
    readonly hideFilterMobilePage: typeof hideFilterMobilePage
}

type IFilterMobilePageProps = IPropsFromState & IPropsFromDispatch

class FilterMobilePage extends React.Component<IFilterMobilePageProps, {}>
{
    constructor(props: IFilterMobilePageProps) {
        super(props);
        this.activateWizardPage = this.activateWizardPage.bind(this);
        this.resetAll = this.resetAll.bind(this);
        this.hideFilterMobilePage = this.hideFilterMobilePage.bind(this);
    }

    public render() {
        return (
            <div className="filter-mobile-page">
                <OverlayWindowComponent title={ResourceProvider.getText('FilterMobilePage.Title')} onClose={this.hideFilterMobilePage} isVisible={this.props.isVisible}
                    footerElement={this.renderFooter()}>
                    <div className="filter-mobile-page-content">
                        {this.props.enteredVin &&
                            <FilterItem resourceTitle='Filter.Vin.Label' value={this.props.enteredVin ? this.props.enteredVin : 'Filter.Item.Unselected'}
                                isSelected={this.props.enteredVin ? true : false} activateWizardTab={TabType.Vin} onclickFunction={this.activateWizardPage} />
                        }
                        {<FilterItem resourceTitle='Filter.Model.Label' value={this.props.selectedModel ? this.props.selectedModel.Title : 'Filter.Item.Unselected'}
                            isSelected={this.props.selectedModel ? true : false} activateWizardTab={TabType.Model} onclickFunction={!this.props.enteredVin ? this.activateWizardPage : null} />
                        }
                        {<FilterItem resourceTitle='Filter.Intofaiment.Label' value={this.props.selectedInfotaiment ? this.props.selectedInfotaiment.Title : 'Filter.Item.Unselected'}
                            isSelected={this.props.selectedInfotaiment ? true : false} activateWizardTab={TabType.Infotainment} onclickFunction={!this.props.enteredVin ? this.activateWizardPage : null} />
                        }
                        {<FilterItem resourceTitle='Filter.ProductionPeriod.Label' value={this.getProductionIntervalValue(this.props.selectedProductionInterval)}
                            isSelected={this.props.selectedProductionInterval ? true : false} activateWizardTab={TabType.ProductionPeriod} onclickFunction={!this.props.enteredVin ? this.activateWizardPage : null} />
                        }
                    </div>
                </OverlayWindowComponent>
            </div>
        );
    }

    private renderFooter(): JSX.Element {
        return (
            <div className="filter-mobile-page-footer">
                <div id="filter-reset" className="filter-reset" onClick={() => { this.resetAll() }}>
                    <div className="filter-reset-button">{ResourceProvider.getText('Filter.Action.Reset')}</div>
                    <div className="filter-reset-image"></div>
                </div>
            </div>
        );
    }

    private renderFilterItem(resourceTitle: string, value: string, isSelected: boolean, activateWizardTab: TabType, onclickFunction: (tab: TabType) => void) {
        return (
            <div className="filter-item" onClick={() => onclickFunction(activateWizardTab)}>
                <div className="filter-title-container">
                    <div className="filter-icon">
                        {this.renderFilterIcon(isSelected)}
                    </div>
                    <div className="filter-title">
                        <p>{ResourceProvider.getText(resourceTitle)}</p>
                    </div>
                </div>
                {this.renderSelectedItem(value, isSelected)}
            </div>
        );
    }

    private renderSelectedItem(value: string, isSelected: boolean): JSX.Element {
        if (isSelected) {
            return (
                <div className="filter-selected-item">
                    {value}
                </div>
            );
        } else {
            return (
                <div className="filter-unselected-item">
                    {ResourceProvider.getText('Filter.Item.Unselected')}
                </div>
            );
        }
    }

    private renderFilterIcon(isSelected: boolean): JSX.Element {
        if (isSelected) {
            return (
                <div className="filter-check-image"></div>
            );
        } else {
            return (
                <div className="filter-uncheck-image"></div>
            );
        }
    }

    private getProductionIntervalValue(productionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel): string {
        if (productionInterval) {
            let result = '';
            if (productionInterval.From) {
                result = ResourceProvider.getText('Filter.ProductionInterval.PrefixFrom') + " " + productionInterval.From.Title;
            }
            if (productionInterval.To) {
                result += " " + ResourceProvider.getText('Filter.ProductionInterval.PrefixTo') + " " + productionInterval.To.Title;
            }
            return result;
        }
        return 'Filter.Item.Unselected';
    }

	private activateWizardPage(activeWizardTab: TabType): void {
		this.props.hideFilterMobilePage();
        this.props.showWizardPage(activeWizardTab, true, (this.props.importerSettings && this.props.importerSettings.VinCheck) ? true : false);
	}

    private resetAll(): void {
        this.props.resetAll();
        this.hideFilterMobilePage();
    }

    private hideFilterMobilePage() {
        this.props.hideFilterMobilePage();
    }
}

const mapStateToProps = ({ filter, filterMobilePage, common }: ApplicationState) => ({
    isVisible: filterMobilePage.isVisible,
    enteredVin: filter.enteredVin,
    selectedVehicleMarketEntry: filter.selectedVehicleMarketEntry,
    selectedModel: filter.selectedModel,
    selectedInfotaiment: filter.selectedInfotaiment,
    selectedProductionInterval: filter.selectedProductionInterval,
    importerSettings: common.importerSettings
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    showWizardPage: (wizardTab: TabType, activateFilterOnClose: boolean, vinCheck: boolean) => dispatch(showWizardPage(wizardTab, activateFilterOnClose, vinCheck)),
	resetAll: () => dispatch(resetAll()),
	hideFilterMobilePage: () => dispatch(hideFilterMobilePage())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterMobilePage)